module.exports = __webpack_public_path__ + "static/img/sheild.96c3d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sheild.png
// module id = K5Mh
// module chunks = 0